module.exports = __webpack_public_path__ + "static/media/train.b7ecabc4.jpg";